import { render } from "./BaseqtySpinner.vue?vue&type=template&id=530a8780&scoped=true"
const script = {}

import "./BaseqtySpinner.vue?vue&type=style&index=0&id=530a8780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530a8780"]])

export default __exports__